import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const seconds = useCountdown(START_SECONDS);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const units = [{
    value: h,
    label: 'Hours'
  }, {
    value: m,
    label: 'Minutes'
  }, {
    value: s,
    label: 'Seconds'
  }];
  return <div className="mt-6 rounded-2xl bg-navy p-4 text-white" role="timer" aria-live="off" data-id="element-78" data-mp="3c48qcjilh3gx">
      <p className="flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wide text-gold" data-id="element-79" data-mp="3gyw8m0n091n2">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="372jbess945nk" />
        Promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-81" data-mp="10btopxe9rgvs">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-82" data-mp="15by7xv6kappp" data-mpi={i}>
            <div className="flex w-20 flex-col items-center" data-id="element-83" data-mp="15awk0q4g68qk">
              <span className="w-full rounded-xl bg-white py-2 text-center text-3xl font-black tabular-nums text-navy sm:text-4xl" data-id="element-84" data-mp="y0n5bzzw5tfu">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-85" data-mp="17r9dj95a3hoi">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 text-3xl font-black text-white/60" data-id="element-86" data-mp="12u97uzcccgxx">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}